import { HouseRuleActionType } from '../contants/actions-type'
const initialState = {}

export default function HouseRuleReducer(
  state = initialState,
  { type, payload },
) {
  switch (type) {
    case HouseRuleActionType.SET_HOUSE_RULE:
      return {
        ...state,
        ...payload,
      }

    case HouseRuleActionType.CREATE_HOUSE_RULE:
      return {
        ...state,
        ...payload,
      }

    default:
      return state
  }
}
